const stats = [
  { value: '500+', label: 'Projects Delivered' },
  { value: '10+', label: 'Years of Experience' },
  { value: '5.0★', label: 'Google Rating' },
  { value: '7+', label: 'Cities Served' },
  { value: '24/7', label: 'Emergency Service' },
];

const badges = [
  { src: 'https://cqc-landscaping.com/wp-content/uploads/sites/548/2024/02/mobile-service.png', alt: 'Mobile Service' },
  { src: 'https://cqc-landscaping.com/wp-content/uploads/sites/548/2024/02/free-consultation.png', alt: 'Free Consultation' },
  { src: 'https://cqc-landscaping.com/wp-content/uploads/sites/548/2024/02/certified-and-licensed.png', alt: 'Certified & Licensed' },
  { src: 'https://cqc-landscaping.com/wp-content/uploads/sites/548/2024/02/family-owned.png', alt: 'Family Owned' },
  { src: 'https://cqc-landscaping.com/wp-content/uploads/sites/548/2024/02/available-appointment2.png', alt: 'Available by Appointment' },
];

export default function TrustBar() {
  return (
    <section className="bg-[#07140a]">
      {/* Top micro-line */}
      <div className="h-[2px] bg-gradient-to-r from-transparent via-gold to-transparent opacity-60"></div>

      {/* Stats */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
          {stats.map((s, i) => (
            <div
              key={i}
              className={`flex flex-col items-center justify-center py-10 px-4 text-center ${i > 0 ? 'border-l border-white/8' : ''}`}
            >
              <span className="font-serif text-3xl lg:text-4xl text-white font-semibold leading-none mb-2">{s.value}</span>
              <span className="font-sans text-[10px] tracking-[0.15em] text-white/35 uppercase">{s.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Badges */}
      <div className="border-t border-white/6">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex flex-wrap items-center justify-between gap-5">
          <span className="font-sans text-[9px] tracking-[0.25em] uppercase text-white/25">Certifications</span>
          <div className="flex items-center gap-8 flex-wrap">
            {badges.map((b) => (
              <img key={b.alt} src={b.src} alt={b.alt} className="h-10 w-10 object-contain opacity-60 hover:opacity-90 transition-opacity" loading="lazy" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
